import { render, staticRenderFns } from "./MungBeanAllocateRechargeDialog.vue?vue&type=template&id=353906fd&scoped=true&lang=pug&"
import script from "./MungBeanAllocateRechargeDialog.vue?vue&type=script&lang=ts&"
export * from "./MungBeanAllocateRechargeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MungBeanAllocateRechargeDialog.vue?vue&type=style&index=0&id=353906fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353906fd",
  null
  
)

export default component.exports